import ReactDOM from 'react-dom';
import React from 'react';
import App from './App';
import './components/Views/FileExplorer/theme.css';

ReactDOM.render(
  <React.StrictMode>
    <App  />
  </React.StrictMode>,
  document.getElementById('root')
);

